import { render, staticRenderFns } from "./ExpectedGoalsArticle.vue?vue&type=template&id=35e61082&"
import script from "./ExpectedGoalsArticle.vue?vue&type=script&lang=js&"
export * from "./ExpectedGoalsArticle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports